export default __webpack_public_path__ + "static/media/ErinHannon.3c090906.jpg";